import React from 'react';

import Group from 'entities/Group';

import GroupEditPanel from './GroupEditPanel';
import GroupMemberList from './GroupMemberList';

export type Props = {
  group: Group;
  onCodeChange: Function;
  onRequestHide?: () => void;
  userIsTeacher: boolean;
  isSettingsTab?: boolean;
};

export function renderGroupOwnerManagerPanel(group: Group, onChange?: () => void) {
  return (
    <GroupMemberList
      className="GroupMemberList"
      group={group}
      onRequestHide={() => {}}
      onChange={onChange}
    />
  );
}
export function renderGroupInformationPanel({
  group,
  onCodeChange,
  userIsTeacher,
  onRequestHide,
  isSettingsTab,
}: Props) {
  return (
    <GroupEditPanel
      group={group}
      onCodeChange={onCodeChange}
      userIsTeacher={userIsTeacher}
      onRequestHide={onRequestHide}
      isSettingsTab={isSettingsTab}
    />
  );
}
